/** Merchants that should not see the Products entry in the side navigation. */
export const MERCHANT_IDS_WITHOUT_PRODUCTS_MENU = ['m-5D48', 'm-5D4J'] as const;
